/**
 * ApiErrorToast — Global API hata bildirimleri
 * apiClient'tan gelen custom event'leri dinler, toast gösterir
 * Auto-dismiss 4s
 */
import { AlertCircle, WifiOff, X } from 'lucide-react';
import { useCallback, useEffect, useState } from 'react';

interface Toast { id: number; message: string; type: 'error' | 'warning' }

let toastId = 0

export default function ApiErrorToast() {
  const [toasts, setToasts] = useState<Toast[]>([])

  const addToast = useCallback((message: string, type: 'error' | 'warning') => {
    const id = ++toastId
    setToasts(prev => [...prev.slice(-3), { id, message, type }]) // max 4
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 4000)
  }, [])

  const remove = useCallback((id: number) => {
    setToasts(prev => prev.filter(t => t.id !== id))
  }, [])

  useEffect(() => {
    const onApiError = (e: Event) => {
      const { message, type } = (e as CustomEvent).detail as { message: string; type: 'error' | 'warning' }
      addToast(message, type)
    }
    const onAuthError = () => addToast('Oturum süresi doldu — tekrar giriş yapın', 'warning')

    window.addEventListener('runai:api-error', onApiError)
    window.addEventListener('runai:auth-error', onAuthError)
    return () => {
      window.removeEventListener('runai:api-error', onApiError)
      window.removeEventListener('runai:auth-error', onAuthError)
    }
  }, [addToast])

  if (toasts.length === 0) return null

  return (
    <div style={{
      position: 'fixed', top: 40, right: 16, zIndex: 10000,
      display: 'flex', flexDirection: 'column', gap: 8, maxWidth: 320,
    }}>
      {toasts.map(t => (
        <div key={t.id} style={{
          display: 'flex', alignItems: 'center', gap: 8,
          padding: '10px 14px', borderRadius: 10,
          background: t.type === 'error' ? 'rgba(239,68,68,0.15)' : 'rgba(245,158,11,0.15)',
          border: `1px solid ${t.type === 'error' ? 'rgba(239,68,68,0.3)' : 'rgba(245,158,11,0.3)'}`,
          backdropFilter: 'blur(16px)',
          color: t.type === 'error' ? '#fca5a5' : '#fcd34d',
          fontSize: 12, animation: 'toastIn 0.3s ease-out',
        }}>
          {t.type === 'error' ? <WifiOff size={14} /> : <AlertCircle size={14} />}
          <span style={{ flex: 1 }}>{t.message}</span>
          <button onClick={() => remove(t.id)} style={{
            background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', padding: 2,
          }}><X size={12} /></button>
        </div>
      ))}
      <style>{`@keyframes toastIn { from { transform: translateX(100%); opacity: 0; } to { transform: translateX(0); opacity: 1; } }`}</style>
    </div>
  )
}
